import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-service-data',
  templateUrl: './service-data.component.html',
  styleUrls: ['./service-data.component.scss']
})
export class ServiceDataComponent implements OnInit {

  @Output() serviceDataForm:EventEmitter<FormGroup> = new EventEmitter();
  @Output() serviceDataStepBack:EventEmitter<boolean> = new EventEmitter();
  @Output() formServiceData:EventEmitter<FormGroup> = new EventEmitter();

  days:number[] = []
  months:number[] = []
  years:number[] = []
  today:Date = new Date()
  valid:boolean = true;

  formGroup!:FormGroup

  constructor(
    private fb: FormBuilder,
    public commonService:CommonService
  ) {

    var todayYear = this.today.getFullYear() + 2;
    this.years = Array(todayYear-2018).fill(1).map((x, i) => todayYear - i)
    this.days = Array(31).fill(1).map((x,i)=>i+1)
    this.months = Array(12).fill(1).map((x,i)=>i+1)

    this.formGroup = this.fb.group({
      day: ['', Validators.required],
      month: ['', Validators.required],
      year: ['', Validators.required],
      description: ['', Validators.required],
    }, {
      validators: [this.validateDate, this.validateDateProduct]
    })
  }
  
  stepBack(){
    this.serviceDataStepBack.emit(true)
  }

  stepOn(){
    if(this.formGroup.valid){
      this.serviceDataForm.emit(this.formGroup)
      this.formServiceData.emit(this.formGroup)
    }
  }
  ngOnInit(): void {
        const {day,month,year} = this.formGroup.value      
  }

  validateDate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const day = control.get('day');
    const month = control.get('month')
    const year = control.get('year')

    const todayDay = this.today.getDate()
    const todayMonth = this.today.getMonth()+1
    const todayYear = this.today.getFullYear()

    if((year && year.value == todayYear && month && month.value > todayMonth)){
      this.formGroup.controls['month'].setValue(todayMonth)
    }else if ((year && year.value == todayYear && month && month.value == todayMonth && day && day.value > todayDay)){
      this.formGroup.controls['day'].setValue(todayDay)
    }
    return null
  };

  validateDateProduct: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const day = control.get('day');
    const month = control.get('month')
    const year = control.get('year')
    const productYear = this.commonService.productDate?.getFullYear();
    const productMonth = this.commonService.productDate?.getMonth() + 1;
    const productDay = this.commonService.productDate?.getDay();
    if ((year && year.value != '' && year.value < productYear)) {
      this.formGroup.controls['year'].setValue('')
      alert('La fecha reportada es anterior a la fecha de compra del artículo')
    } else if (year && year.value == productYear && (month && month.value != '' && month.value < productMonth)) {
      alert('La fecha reportada es anterior a la fecha de compra del artículo')
      this.formGroup.controls['month'].setValue('')
      this.formGroup.controls['year'].setValue('')

    } else if (year && year.value == productYear && (month && month.value == productMonth) && (day && day.value != '' && day.value < productDay)) {
      alert('La fecha reportada es anterior a la fecha de compra del artículo')
      this.formGroup.controls['day'].setValue('')
      this.formGroup.controls['month'].setValue('')
      this.formGroup.controls['year'].setValue('')
    }
    return null
  };
  

}
